import React from 'react';
import { LazyImg } from 'src/hooks/useLazyLoad';
import { CustomLink } from 'src/components/CustomLink/CustomLink';
import classnames from 'classnames';

import { DefaultImage } from '../ImageAndText/ImageAndText';

import classes from './ImageAndHoverText.scss';

type ImageAndHoverTextProps = {
    title: string;
    link: string;
    image: string;
    smallImage?: boolean;
};

export const ImageAndHoverText: React.FC<ImageAndHoverTextProps> = ({ title, link, image, smallImage = false }) => (
    <li className={classnames(classes.wrapper, { [classes.smallImage]: smallImage })}>
        <CustomLink link={link} className={classes.link}>
            <div className={classes.imageContainer}>
                <DefaultImage />
                <LazyImg className={classes.image} src={image} alt={title} />
            </div>
            <div className={classes.title}>
                <h3>{title}</h3>
            </div>
        </CustomLink>
    </li>
);
